import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _styled from "styled-components";
var _excluded = ["className", "css", "iconSize", "isDark", "isTransparent"];
import PencilRuler from "@crehana/icons/PencilRuler";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated

import cn from "classnames";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { css } from "styled-components";
import { jsx as _jsx } from "react/jsx-runtime";
var ProjectEmptyCover = function ProjectEmptyCover(_ref) {
  var className = _ref.className,
    cssProp = _ref.css,
    _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? 104 : _ref$iconSize,
    isDark = _ref.isDark,
    isTransparent = _ref.isTransparent,
    projectEmptyCoverProps = _objectWithoutProperties(_ref, _excluded);
  var responsiveIconSize = typeof iconSize !== 'number' ? {
    xs: iconSize.xs,
    sm: iconSize.sm || iconSize.xs,
    md: iconSize.md || iconSize.sm || iconSize.xs,
    lg: iconSize.lg || iconSize.md || iconSize.sm || iconSize.xs
  } : undefined;
  var responsiveIconSizeCss = responsiveIconSize ? css(["\n        & > svg {\n          width: ", "px;\n          height: ", "px;\n          ", " {\n            width: ", "px;\n            height: ", "px;\n          }\n          ", " {\n            width: ", "px;\n            height: ", "px;\n          }\n          ", " {\n            width: ", "px;\n            height: ", "px;\n          }\n        }\n      "], responsiveIconSize.xs, responsiveIconSize.xs, function (_ref2) {
    var theme = _ref2.theme;
    return theme.breakpoints.up('sm');
  }, responsiveIconSize.sm, responsiveIconSize.sm, function (_ref3) {
    var theme = _ref3.theme;
    return theme.breakpoints.up('md');
  }, responsiveIconSize.md, responsiveIconSize.md, function (_ref4) {
    var theme = _ref4.theme;
    return theme.breakpoints.up('lg');
  }, responsiveIconSize.lg, responsiveIconSize.lg) : undefined;
  var wrapperCss = cssProp ? css(["\n        ", "\n        ", "\n      "], responsiveIconSizeCss, cssProp) : responsiveIconSizeCss;
  var backgroundClassName = isDark ? 'bg-gray-main-dark-mode' : 'bg-gray-light';
  return /*#__PURE__*/_jsx(_StyledDiv, _objectSpread(_objectSpread({
    className: cn('flex items-center justify-center flex-shrink-0 text-base-lighter', _defineProperty({}, backgroundClassName, !isTransparent), className)
  }, projectEmptyCoverProps), {}, {
    $_css: wrapperCss,
    children: /*#__PURE__*/_jsx(PencilRuler, {
      size: typeof iconSize === 'number' ? iconSize : undefined,
      ignoreColor: true,
      className: "fill-current"
    })
  }));
};
export default ProjectEmptyCover;
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-1a1ww3e-0"
})(["", ""], function (p) {
  return p.$_css;
});